(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cinematic-product-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  var GSAP_URL = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var SCROLLTRIGGER_URL = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
  var loaderPromise = null;
  var registry = new Map();

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.getAttribute('data-loaded') === 'true') return resolve();
        existing.addEventListener('load', resolve);
        existing.addEventListener('error', reject);
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = function () {
        script.setAttribute('data-loaded', 'true');
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function loadGSAP() {
    if (!loaderPromise) {
      loaderPromise = loadScript(GSAP_URL).then(function () { return loadScript(SCROLLTRIGGER_URL); });
    }
    return loaderPromise;
  }

  function shouldAnimate() {
    return (
      window.ShorreFindsMotionEnabled !== false &&
      window.matchMedia('(min-width: 990px)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function setup(section) {
    if (registry.has(section)) return;
    var pin = section.querySelector('[data-story-pin]');
    var images = Array.prototype.slice.call(section.querySelectorAll('[data-story-image]'));
    var texts = Array.prototype.slice.call(section.querySelectorAll('[data-story-text]'));
    var highlight = section.querySelector('[data-story-highlight]');
    var stageCount = images.length;
    var state = { mm: null };
    registry.set(section, state);

    function setStage(index) {
      images.forEach(function (img, i) { img.classList.toggle('is-active', i === index); });
      texts.forEach(function (t, i) {
        var active = i === index;
        t.classList.toggle('is-active', active);
        t.hidden = !active;
      });
      if (highlight) highlight.hidden = index !== stageCount - 1;
    }

    setStage(0);

    if (!shouldAnimate()) return;

    loadGSAP().then(function () {
      if (!registry.has(section) || !shouldAnimate()) return;
      gsap.registerPlugin(ScrollTrigger);
      var mm = gsap.matchMedia();
      state.mm = mm;

      mm.add('(min-width: 990px)', function () {
        var distance = parseInt(section.getAttribute('data-scroll-distance'), 10) || 200;
        section.classList.add('story--animating');

        var st = ScrollTrigger.create({
          trigger: pin,
          start: 'top top',
          end: '+=' + distance + '%',
          scrub: 0.6,
          pin: true,
          anticipatePin: 1,
          onUpdate: function (self) {
            var stage = Math.min(stageCount - 1, Math.floor(self.progress * stageCount));
            setStage(stage);
          }
        });

        return function () {
          section.classList.remove('story--animating');
          st.kill();
        };
      });
    }).catch(function () {
      setStage(0);
    });
  }

  function teardown(section) {
    var state = registry.get(section);
    if (!state) return;
    if (state.mm) state.mm.revert();
    registry.delete(section);
  }

  function init() {
    document.querySelectorAll('[data-story-section]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-story-section]');
    if (section) setup(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('[data-story-section]');
    if (section) teardown(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function () {
        var panel = document.querySelector('[data-filter-panel]');
        if (!panel) return;
        var isOpen = panel.classList.toggle('is-open');
        panel.hidden = !isOpen;
      });
    });

    document.querySelectorAll('[data-sort-select]').forEach(function (select) {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', function () {
        select.closest('form').submit();
      });
    });

    document.querySelectorAll('[data-filter-input]').forEach(function (input) {
      if (input.dataset.bound) return;
      input.dataset.bound = 'true';
      input.addEventListener('change', function () {
        input.closest('form').submit();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-related-products]').forEach(function (el) {
      if (el.dataset.loaded) return;
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newContent = doc.querySelector('[data-related-products]');
          if (newContent && newContent.innerHTML.trim() !== '') {
            el.innerHTML = newContent.innerHTML;
            el.dataset.loaded = 'true';
          }
        })
        .catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-related-products]')) init();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
